import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ClientSidebar from '../../components/ClientSidebar';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Switch } from '../../components/ui/switch';
import { Label } from '../../components/ui/label';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Bell, Mail, MessageSquare, Shield, Menu } from 'lucide-react';

const Preferences = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen">
      <ClientSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
      <div className="flex-1 bg-gray-50">
        {/* Mobile Header - Black to match logo */}
        <div className="md:hidden bg-black text-white p-4 flex items-center justify-between">
          <button 
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-2 hover:bg-white/10 rounded-lg transition-colors"
          >
            <Menu className="h-6 w-6" />
          </button>
          <Link to="/client/dashboard">
            <img 
              src="https://customer-assets.emergentagent.com/job_younited-clone-1/artifacts/y6hpz6h2_IMG_0359.jpeg"
              alt="Younited"
              className="h-8 object-contain"
            />
          </Link>
          <div className="w-10"></div>
        </div>

        {/* Desktop Header */}
        <div className="hidden md:block bg-gray-800 text-white py-3 px-8 text-sm">
          Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager.
        </div>

        {/* Main Content */}
        <div className="max-w-4xl mx-auto p-4 md:p-8">
          <h1 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 md:mb-8">Mes préférences</h1>

          <Tabs defaultValue="communication" className="space-y-6">
            <TabsList className="bg-white border border-gray-200 p-1 flex-wrap">
              <TabsTrigger
                value="communication"
                className="data-[state=active]:bg-purple-50 data-[state=active]:text-purple-700 text-xs md:text-sm"
              >
                Communication
              </TabsTrigger>
              <TabsTrigger
                value="security"
                className="data-[state=active]:bg-purple-50 data-[state=active]:text-purple-700 text-xs md:text-sm"
              >
                Sécurité
              </TabsTrigger>
              <TabsTrigger
                value="notifications"
                className="data-[state=active]:bg-purple-50 data-[state=active]:text-purple-700 text-xs md:text-sm"
              >
                Notifications
              </TabsTrigger>
            </TabsList>

            <TabsContent value="communication">
              <Card className="p-4 md:p-8">
                <div className="space-y-6">
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-3 md:mb-4 text-sm md:text-base">Gérer vos préférences</h3>
                    <p className="text-xs md:text-sm text-gray-600 mb-4 md:mb-6">
                      Principe de renouvellement par l'article CAF les offres commerciales de Younited CA et de Younited.
                      Vous recevez tous là-dessus de communication toute marque offres commerciaux. Lancement offres commerciale
                      donnée enregistrée voir champ.
                    </p>
                    <Button
                      className="text-white font-medium text-sm"
                      style={{ backgroundColor: '#8B5CF6' }}
                    >
                      Enregistrer mes préférences
                    </Button>
                  </div>

                  <div className="border-t border-gray-200 pt-6">
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center space-x-3">
                        <Mail className="h-5 w-5 text-purple-600 flex-shrink-0" />
                        <div>
                          <Label className="font-medium text-gray-900 text-sm">Recevoir les emails</Label>
                          <p className="text-xs md:text-sm text-gray-600">Notifications et offres par email</p>
                        </div>
                      </div>
                      <Switch defaultChecked />
                    </div>

                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center space-x-3">
                        <MessageSquare className="h-5 w-5 text-purple-600 flex-shrink-0" />
                        <div>
                          <Label className="font-medium text-gray-900 text-sm">Recevoir les SMS</Label>
                          <p className="text-xs md:text-sm text-gray-600">Alertes et confirmations par SMS</p>
                        </div>
                      </div>
                      <Switch defaultChecked />
                    </div>

                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <Bell className="h-5 w-5 text-purple-600 flex-shrink-0" />
                        <div>
                          <Label className="font-medium text-gray-900 text-sm">Notifications push</Label>
                          <p className="text-xs md:text-sm text-gray-600">Alertes sur l'application mobile</p>
                        </div>
                      </div>
                      <Switch />
                    </div>
                  </div>
                </div>
              </Card>
            </TabsContent>

            <TabsContent value="security">
              <Card className="p-4 md:p-8">
                <div className="space-y-6">
                  <div className="flex items-start space-x-3 md:space-x-4">
                    <div className="p-2 md:p-3 rounded-lg bg-purple-50 flex-shrink-0">
                      <Shield className="h-5 w-5 md:h-6 md:w-6 text-purple-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-2 text-sm md:text-base">Sécurité renforcée</h3>
                      <p className="text-gray-600 mb-4 text-xs md:text-sm">
                        Activez l'authentification à deux facteurs pour sécuriser davantage votre compte
                      </p>
                      <Button variant="outline" className="text-sm">Configurer</Button>
                    </div>
                  </div>
                </div>
              </Card>
            </TabsContent>

            <TabsContent value="notifications">
              <Card className="p-4 md:p-8">
                <p className="text-gray-600 text-sm">Gérez vos préférences de notifications ici.</p>
              </Card>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default Preferences;
